export const getAlertData = (
  type: string,
  name: string = "",
  customAlertType: string = "provide a custom type",
  title: string = "provide a custom message",
) => {
  switch (type) {
    case alertConstants.info: {
      return { type: "info", title: "title", case: type };
    }
    case alertConstants.error: {
      return { type: "error", title: "Failure", case: type };
    }
    case alertConstants.success: {
      return { type: "success", title: "Success", case: type };
    }
    case alertConstants.emailSuccess: {
      return { type: "success", title: "Email Sent Successfully!", case: type };
    }
    case alertConstants.warning: {
      return { type: "warning", title: "Warning", case: type };
    }
    case alertConstants.conflict: {
      return { type: "error", title: `Already exists!`, case: type };
    }
    case alertConstants.expectationFailed: {
      return { type: "error", title: "Code already exists !", case: type };
    }
    case alertConstants.cancelCheck: {
      return { type: "warning", title: "Do you want to cancel ?", case: type };
    }
    case alertConstants.deleteCheck: {
      return {
        type: "warning",
        title: "Do you want to delete this item ?",
        case: type,
      };
    }
    case alertConstants.deleteSuccess: {
      return {
        type: "success",
        title: "Item deleted successfully",
        case: type,
      };
    }
    case alertConstants.deleteFailure: {
      return { type: "error", title: "Error in deleting Item", case: type };
    }
    case alertConstants.unSavedClose: {
      return {
        type: "warning",
        title: "Unsaved data will be lost",
        case: type,
      };
    }
    case alertConstants.fileRequired: {
      return {
        type: "error",
        title: "File is required",
        case: type,
      };
    }
    case alertConstants.inactiveCheck: {
      return {
        type: "warning",
        title: "Do you want to inactivate this item ?",
        case: type,
      };
    }
    case alertConstants.inactiveSuccess: {
      return {
        type: "success",
        title: "Item inactivated successfully",
        case: type,
      };
    }
    case alertConstants.inactiveFailure: {
      return { type: "error", title: "Error in inactivating Item", case: type };
    }
    default: {
      return { type: customAlertType, title: title, case: type };
    }
  }
};

export const alertConstants = {
  success: "success",
  error: "error",
  warning: "warning",
  conflict: "conflict",
  expectationFailed: "expectationFailed",
  cancelCheck: "cancelCheck",
  deleteCheck: "deleteCheck",
  deleteSuccess: "deleteSuccess",
  deleteFailure: "deleteFailure",
  custom: "custom",
  unSavedClose: "unSavedClose",
  fileRequired: "fileRequired",
  inactiveCheck: "inactiveCheck",
  inactiveSuccess: "inactiveSuccess",
  inactiveFailure: "inactiveFailure",
  info: "info",
  emailSuccess: "emailSuccess"
};
